import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { TextField } from '@mui/material'
import { PatternFormat } from 'react-number-format'

const Masked = ({
  control,
  name,
  rules,
  id,
  placeholder,
  type = 'text',
  block = false,
  disabled,
  numberFormat,
  prefix,
  normalizers,
  onValueChange,
  ...textFieldProps
}) => {
  const fieldId = id ?? name
  const inputRef = React.useRef(null)

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <PatternFormat
          id={fieldId}
          name={field.name}
          customInput={TextField}
          value={field.value ?? ''}
          format={numberFormat || ''}
          mask='_'
          fullWidth={block}
          disabled={disabled}
          prefix={prefix}
          inputRef={(node) => {
            inputRef.current = node
            field.ref(node)
          }}
          onChange={(event) => {
            const input = inputRef.current
            const selectionStart = input?.selectionStart
            const selectionEnd = input?.selectionEnd
            const raw = event.target.value
            const value = normalizers
              ? normalizers.reduceRight((current, normalize) => normalize(current), raw)
              : raw

            field.onChange(value)
            onValueChange?.(value)

            if (input && value !== raw && selectionStart != null) {
              queueMicrotask(() => {
                input.setSelectionRange(selectionStart, selectionEnd)
              })
            }
          }}
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          label={placeholder}
          type={type}
          margin='normal'
          slotProps={{
            htmlInput: {
              'data-testid': `test-${fieldId}`
            },
            formHelperText: {
              'data-testid': `test-${fieldId}-helper-text`
            }
          }}
          {...textFieldProps}
        />
      )}
    />
  )
}

Masked.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  numberFormat: PropTypes.string,
  prefix: PropTypes.string,
  normalizers: PropTypes.array,
  onValueChange: PropTypes.func
}

export default Masked
